/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import {
  Button,
  ButtonContainer,
  HasPermission,
  ContentCard,
  CheckBox,
  FormContainer,
  GroupFormContainer,
  FormSectionGlobal
} from '@fitinsur/components';
import IMask from 'imask';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { PMT } from '@fitinsur/utils';
import { GlobalAuthContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import moment from 'moment'
import {
  AddButton,
  Content,
  TitleBar,
  TitleInfo,
  TitleAlter,
  OptionSummary,
  OptionSummaryTitle,
  OptionSummaryValue,
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { camelCase, cloneDeep, isEmpty, uniqueId } from 'lodash';
import MasksHelper from 'utils/src/masks';
import Icon from 'components/Icon'
import * as yup from 'yup';
import {
  useGetQuestionnaireAnswer,
  useDeleteQuestionnaireAnswer,
  useSaveQuestionnaireAnswer
} from 'services/QuestionnaireAnswerService';
import { LoaderContext } from '@fitinsur/contexts'
import {
  useGetDocuments,
  useGetDocumentsAsync
} from '@fitinsur/services/DocumentsService';
import { groupMultipleFieldQuestions, onValidationError, removeAnswersDuplicateSession } from 'containers/edit/handleQuestionChange';
import { useGetOperationAsync } from 'services/OperationService';
import { useSaveQuestionsPayments } from 'services/QuestionnaireAnswerService';
import {
  useRequestIssueAction,
  useRequestSompoGetInternalProcessNumber,
  useRequestSompoGetIssueQuotePolicy,
  useRequestSompoGetIssueQuoteBill,
  useSignatureDocumentSompo
} from 'services/IssueService';
import { useCheckMaxOperationAmount } from '@fitinsur/services/OperationService';
import { ModalEditConfirmation } from 'components';
import Colors from "../../constants/Colors";
import {
  useCheckConsumption
} from '@fitinsur/services/CreditLimitService';

export default function EditEnquirity({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const validationSchema = useRef(yup.object().shape({}));
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const location = useLocation();
  const handleBack = () => history.goBack();
  const maskHelper = new MasksHelper();
  let executeBindRequest = useRef(false);
  let clientCnpj = useRef("");

  const [isBound, setIsBound] = useState(true);
  const [operation, setOperation] = useState({});
  const [dialogTerms, setDialogTerms] = useState({
    visible: false,
    title: '',
    icon: '',
    args: null,
    questions: []
  });
  const [coverageOption, setCoverageOption] = useState(location?.state?.option == null ? 0 : location?.state?.option)
  const [idProductPlanSelected, setIdProductPlanSelected] = useState(location?.state?.idProductPlanSelected == null ? 0 : location?.state?.idProductPlanSelected)
  const [questionnaire, setQuestionnaire] = useState([])
  const [information, setInformation] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
  const [visibleSection, setVisibleSection] = useState(false);
  const [totalInstallments, setTotalInstallments] = useState('');
  const [dialogConfirmationEmission, setDialogConfirmationEmission] = useState({ visible: false });
  const [documentOrder, setDocumentOrder] = useState({ genCertificate: false });
  const [idPersonRelationship, setIdPersonRelationship] = useState(null);
  const [tomadorInfo, setTomadorInfo] = useState({ hasAttachtments: false, needWarranty: false });
  const [idIssueOperation, setIdIssueOperation] = useState(null);
  const [collapseAll, setCollapseAll] = useState(null);

  const [isRefund, setIsRefund] = useState(false);
  const [generateBill, setGenerateBill] = useState(true);

  const getQuestionnaire = useRef(false);

  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: 0,
      coverageAmount: 0,
      coverageComissionRate: 0,
      coverageComission: 0,
      coverageTax: 0,
      coverageAmountTaxLess: 0,
      deductibleDescription: "",
      coverageItems: []
    }]
  }])

  const noRefoundOrPayment = questionnaire.find(
    qst => qst.idQuestion === 3523
  )?.idAnswerOption === 9064;

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useGetDocumentsAsyncLoading,
    request: useGetDocumentsAsyncRequest
  } = useGetDocumentsAsync(idIssueOperation);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    loading: useGetOperationLoading,
    request: useGetOperationRequest
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    loading: useSaveQuestionnaireAnswerLoading,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useRequestSompoGetInternalProcessNumberLoading,
    request: useRequestSompoGetInternalProcessNumberRequest,
  } = useRequestSompoGetInternalProcessNumber();

  const {
    loading: useRequestSompoGetIssueQuotePolicyLoading,
    request: useRequestSompoGetIssueQuotePolicyRequest,
  } = useRequestSompoGetIssueQuotePolicy();

  const {
    loading: useRequestSompoGetIssueQuoteBillLoading,
    request: useRequestSompoGetIssueQuoteBillRequest,
  } = useRequestSompoGetIssueQuoteBill();

  const {
    loading: useRequestIssueActionLoading,
    request: useRequestIssueActionRequest,
  } = useRequestIssueAction();

  const {
    loading: useDeleteQuestionnaireLoading,
    status: useDeleteQuestionnaireStatus,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useSaveQuestionsPaymentsLoading,
    request: useSaveQuestionsPaymentsRequest
  } = useSaveQuestionsPayments(props.match.params.idOperation);

  const {
    loading: useCheckConsumptionLoading,
    request: useCheckConsumptionRequest,
  } = useCheckConsumption(props?.match?.params?.idOperation);

  const {
    loading: useSignatureDocumentSompoRequestLoading,
    request: useSignatureDocumentSompoRequest
  } = useSignatureDocumentSompo();

  const {
    loading: useCheckMaxOperationAmountLoading,
    request: useCheckMaxOperationAmountRequest,
  } = useCheckMaxOperationAmount(props?.match?.params?.idOperation);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      getQuestionnaire.current = true;
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (!useGetDocumentsStatus) return;
    if (useGetDocumentsStatus === 200 && idProductPlanSelected) {
      const [quoteRequestDocument] = useGetDocumentsData.value;

      if (quoteRequestDocument.documentCoverageList?.coverageCalcList[0]?.coverageCalc) {
        let coverageCalc = quoteRequestDocument.documentCoverageList?.coverageCalcList.find(calc => calc.idProductPlan == idProductPlanSelected).coverageCalc
        setCoverageCalcList(coverageCalc);
      } else {
        setCoverageCalcList(quoteRequestDocument.documentCoverageList?.coverageCalcList);
      }
      useGetQuestionnairesAnswersRequest();
    }
  }, [useGetDocumentsStatus, idProductPlanSelected])

  useEffect(() => {
    updateIsLoadingStatus(
      useGetQuestionnairesAnswersLoading ||
      useGetDocumentsLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useDeleteQuestionnaireLoading ||
      useSaveQuestionsPaymentsLoading ||
      useRequestSompoGetInternalProcessNumberLoading ||
      useRequestSompoGetIssueQuotePolicyLoading ||
      useRequestSompoGetIssueQuoteBillLoading ||
      useRequestIssueActionLoading ||
      useCheckConsumptionLoading ||
      useGetDocumentsAsyncLoading ||
      useSignatureDocumentSompoRequestLoading ||
      useCheckMaxOperationAmountLoading
    )
  }, [
    useGetQuestionnairesAnswersLoading,
    useGetDocumentsLoading,
    useSaveQuestionnaireAnswerLoading,
    useDeleteQuestionnaireLoading,
    useSaveQuestionsPaymentsLoading,
    useRequestSompoGetInternalProcessNumberLoading,
    useRequestSompoGetIssueQuotePolicyLoading,
    useRequestSompoGetIssueQuoteBillLoading,
    useRequestIssueActionLoading,
    useCheckConsumptionLoading,
    useGetDocumentsAsyncLoading,
    useSignatureDocumentSompoRequestLoading,
    useCheckMaxOperationAmountLoading
  ]);

  useEffect(() => {
    const handleSigningPolicyDocument = async () => {
      const { data: dataDocuments } = await useGetDocumentsAsyncRequest(null, {
        idDomain: 362
      });

      let responseStatus;
      if (dataDocuments?.value?.length) {
        let requestCount = 0;
        const [policyPackDocument] = dataDocuments?.value;
        while (requestCount === 0 || responseStatus !== 200) {
          try {
            requestCount++;
            if (requestCount > 5) break;
            const { data: signatureResponse } = await useSignatureDocumentSompoRequest({
              idDocument: policyPackDocument?.idDocument
            });
            responseStatus = signatureResponse.ret_code;
          } catch {
            responseStatus = 500;
          }
        }
      }

      if (responseStatus && responseStatus !== 200) {
        mc.error(`Não foi possível gerar/autenticar ${operation?.idDomain === 26 ? 'a apólice' : 'o endosso'}, acesse a pasta de documentos e tente novamente`);
      }

      history.push(`/payment-pack/${props.match.params.idOperation}`);
    };

    if (idIssueOperation) handleSigningPolicyDocument();
  }, [idIssueOperation]);

  const SECTIONS = {
    PAYMENT: { name: 'PAYMENT', isMultiple: false, isRisk: false },
    INFORMATION: { name: 'INFORMATION', isMultiple: true, isRisk: false },
    OPERATION_INFO: { name: 'OPERATION_INFO', isMultiple: false, isRisk: false },
    INSURED: { name: 'INSURED', isMultiple: false, isRisk: false },
    PAYMENT_INSTALLMENTS: { name: 'PAYMENT_INSTALLMENTS', isMultiple: true, isRisk: false },
    TERMS: { name: 'TERMS', isMultiple: false, isRisk: false },
  };

  const handleOperationInfo = () => {
    useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
      let operationData;
      if (response.status === 200) {
        operationData = response.data?.value;
        setOperation(operationData);

        if (operationData.operationMetadata.idProductPlanSelected) {
          setCoverageOption(operationData.operationMetadata.coverageOption)
          setIdProductPlanSelected(operationData.operationMetadata.idProductPlanSelected)
        } else {
          history.push(`/quote/plans/${operationData.idProduct}/${operationData.idOperation}`)
        }

        setIsBound([5, 2, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
      }
    });
  }

  const handleQuestionnaire = async (data) => {
    try {
      // updateIsLoadingStatus(true);
      formikRef.current.setValues({});
      setInstallments([])
      setQuestionnaire([]);
      setTimeout(() => {
        let questionnaire = [];
        questionnaire = [
          ...data.persons,
          ...data.operations,
          ...data.payments,
          ...data.risks
        ];
        questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

        const isRefund = coverageCalcList[coverageOption].adjustmentCoverageAmount < 0;
        if (coverageCalcList[coverageOption].adjustmentCoverageAmount != null) {
          setGenerateBill(coverageCalcList[coverageOption].adjustmentCoverageAmount > 0)
        }
        setIsRefund(isRefund);

        const noRefoundOrPayment = questionnaire.find(
          qst => qst.idQuestion === 3523
        )?.idAnswerOption === 9064;

        questionnaire = questionnaire.map(qst => {
          if ([3459, 3460, 1586].includes(qst.idQuestion) && isRefund) {
            qst.disabled = true;

            if (qst.idQuestion === 1586) qst.visibleQuestion = false;
          }

          if ([3524, 3525, 3526, 3527, 3528].includes(qst.idQuestion) && !isRefund) {
            qst.visibleQuestion = false;
          }

          if (qst.behaviorObject.sectionName === 'PAYMENT' && noRefoundOrPayment) {
            qst.visibleQuestion = false;
          }

          return qst;
        });

        let total = 0;
        let mask = null;
        const installmentGroups = groupMultipleFieldQuestions(
          3461,
          questionnaire,
          operation,
          isBound
        )
          .map(group => {
            group.map(qst => {
              if (qst.idQuestion === 3461 && qst.answer) setVisibleSection(true);

              if (qst.idQuestion === 3463 && qst.answer) {
                if (!mask) mask = qst.fieldMask
                total += parseFloat(qst.answer);
              }

              if (noRefoundOrPayment) qst.visibleQuestion = false;

              qst.disabled = true;
              qst.behaviorObject.desktopWidth = 33;
              return qst;
            });
            return group
          });

        if (mask && total != 0) {
          const masked = IMask.createMask(mask);
          setTotalInstallments(
            `R$ ${masked.resolve(String(total).replace('.', ','))}`
          );
        }

        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 3459 && isRefund) {
            const answerOption = qst.answerOptions.find(q => q.idAnswerOption === 9071);
            qst.idAnswerOption = answerOption.idAnswerOption;
            qst.answer = answerOption.dsAnswerOption;
            return qst;
          }

          if (qst.idQuestion === 3460) {
            const coverageAmount = coverageCalcList[coverageOption].adjustmentCoverageAmount != null ? coverageCalcList[coverageOption].adjustmentCoverageAmount : coverageCalcList[coverageOption].coverageAmount;
            const termDaysAmount = questionnaire.find(qst => qst.idQuestion === 3449)?.answer;
            const termLastDay = questionnaire.find(qst => qst.idQuestion === 3448)?.answer;
            let questionWithFilteredOptions = { ...qst, answerOptions: qst.answerOptions };

            if (coverageAmount <= 1000) {
              questionWithFilteredOptions.behaviorObject.defaultValue = 9004
            }

            // The last installment due date must be 60 days, or less, before the end of the term
            if (termLastDay) {
              // If the term is 60 days or less, only allow payment in full
              if (termDaysAmount <= 60) {
                questionWithFilteredOptions.behaviorObject.defaultValue = 9004
                questionWithFilteredOptions.answerOptions = questionWithFilteredOptions.answerOptions.filter(option =>
                  option.idAnswerOption === 9004
                )
              } else {
                const lastInstallmentMaxDate = moment(termLastDay).subtract(60, 'days');
                
                questionWithFilteredOptions.answerOptions = questionWithFilteredOptions.answerOptions.filter(option => {
                  try {
                    const resultValue = JSON.parse(option.behaviorObject.resultValue); // [thereIsADownPayment, numberOfInstallments, interestRate]
                    const numberOfInstallments = resultValue[1];
                    // Com a nova lógica SOMPO RCG:
                    // - 1 parcela: primeira parcela vence em hoje + 10 dias
                    // - Múltiplas parcelas: última parcela = hoje + (numberOfInstallments - 1) meses
                    const lastInstallmentDate = numberOfInstallments === 1
                      ? moment().add(10, 'days')
                      : moment().add(numberOfInstallments - 1, 'months');
  
                    return lastInstallmentDate.isSameOrBefore(lastInstallmentMaxDate, 'day');
                  } catch (e) {
                    return true;
                  }
                });
  
                if (questionWithFilteredOptions.answerOptions.length === 0) {
                  questionWithFilteredOptions.answerOptions = qst.answerOptions.filter(option => 
                    option.idAnswerOption === 9004
                  );
                }
                
                if (questionWithFilteredOptions.answerOptions.length === 1 && questionWithFilteredOptions.answerOptions[0].idAnswerOption === 9004) {
                  questionWithFilteredOptions.behaviorObject.defaultValue = 9004;
                }
              }
            }

            if (isRefund) {
              const answerOption = questionWithFilteredOptions.answerOptions.find(q => q.idAnswerOption === 9004);
              questionWithFilteredOptions.idAnswerOption = answerOption.idAnswerOption;
              questionWithFilteredOptions.answer = JSON.stringify(answerOption.behaviorObject.resultValue);
              return questionWithFilteredOptions;
            }

            return questionWithFilteredOptions
          }

          if (qst.idQuestion === 3478) {
            const firstInstallmentDueDateQuestion = { ...qst, answerJson: qst.answer }
            const installmentMethodQuestion = questionnaire.find(qst => qst.idQuestion === 3460);

            if (
              installmentMethodQuestion?.answer &&
              (JSON.parse(installmentMethodQuestion.answer)[0] === 0)) {
              firstInstallmentDueDateQuestion.disabled = true;
            }

            if (
              installmentMethodQuestion?.answer &&
              (JSON.parse(installmentMethodQuestion.answer)[0] === 1)) {
              firstInstallmentDueDateQuestion.behaviorObject = {
                ...firstInstallmentDueDateQuestion.behaviorObject,
                fieldMaxValue: 29
              }
            }

            return firstInstallmentDueDateQuestion
          }

          return qst;
        });

        setInstallments(installmentGroups)
        setQuestionnaire(questionnaire);
        // updateIsLoadingStatus(false);
      }, 300)
    } catch (e) {
      console.log(e)
    }
    // setInformation(add_information);
  }

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete });
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  const handleCheckConsumption = async (isIssue = true) => {
    try {
      return true;
      if (![26, 398, 400].includes(operation?.idDomain)) return true;
      const { data: consumptionData } = await useCheckConsumptionRequest({}, { isIssue });
      return !!consumptionData?.value?.availableLimit;
    } catch (err) {
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error("Falha ao confirmar a sua cotação, tente novamente!")
      }
      return false;
    }
  }

  const handleCheckMaxOperationAmount = async () => {
    try {
      return true;
      if (![26, 398].includes(operation?.idDomain)) return true;
      const { data: validationData } = await useCheckMaxOperationAmountRequest();
      return !!validationData?.value?.allowedOperationAmount;
    } catch (err) {
      if (err?.response?.data?.errors?.length) {
        err?.response?.data?.errors.map(error => mc.error(error.message))
      } else {
        mc.error("Falha ao confirmar a sua cotação, tente novamente!")
      }
      return false;
    }
  }

  async function quoteIssue() {
    const allowedOperationAmount = await handleCheckMaxOperationAmount();
    if (!allowedOperationAmount) return;
    const canConsumeLimit = await handleCheckConsumption(true);
    if (!canConsumeLimit) return;

    const installmentsDueDateArray = installments.map(installment => installment.find(qst => qst.idQuestion === 3462).answer)

    await useSaveQuestionsPaymentsRequest({
      questionnaire: {
        coverageOptionSelected: coverageOption,
        idProductPlan: idProductPlanSelected,
        idPersonRelationship,
        idPersonRelationshipLimit: coverageCalcList[coverageOption]?.coverageLimit,
      },
      coverageOptionSelected: coverageOption,
      idPersonRelationship,
      idPersonRelationshipLimit: coverageCalcList[coverageOption]?.coverageLimit,
      idProductPlan: idProductPlanSelected,
      isDraft: true,
      generateContract: documentOrder.genCertificate
    }).then(async (response) => {
      if (response.status !== 200) {
        return mc.error("Ocorreu um erro durante a solicitação.");
      } else {

        const files = []

        const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;

        let internalProcessNumberValidate;

        if (hasInternalProcessNumberAnswer) {
          internalProcessNumberValidate = true;
        } else {
          mc.success("Emissão em andamento.");
          // ######################## Generate internal process number ########################
          await useRequestSompoGetInternalProcessNumberRequest({
            idOperation: props.match.params.idOperation
          }).then(async (response) => {
            if (response.status !== 200) {
              internalProcessNumberValidate = false;
              return mc.error('Ocorreu um erro na requisição do sistema externo');
            } else {
              internalProcessNumberValidate = true;
            }
          })
          // ######################## Generate internal process number ########################
        }

        if (!internalProcessNumberValidate) {
          return mc.error('Número de processo interno não foi gerado');
        } else {

          // ######################## Issue Quote Bill ##########################################
          if (generateBill) {
            mc.success(`Emissão ${installmentsDueDateArray.length > 1 ? 'dos boletos' : 'do boleto'} em andamento.`);

            for (const dueDate of installmentsDueDateArray) {
              const billResponse = await useRequestSompoGetIssueQuoteBillRequest({
                idOperation: props.match.params.idOperation,
                dueDate
              });

              if (billResponse.status === 200) {
                files.push(...billResponse.data?.ret_value?.files);
              } else {
                return mc.error(`Erro na requisição do sistema externo. Não foi possível emitir ${installmentsDueDateArray.length > 1 ? 'os' : 'o'} boleto de pagamento.`);
              }
            }
          }
          // ######################## Issue Quote Bill ##########################################

          // ######################## Issue Quote Policy ##########################################
          mc.success(`Emissão ${operation?.idDomain === 26 ? 'da apólice' : 'do endosso'} em andamento.`);
          await useRequestSompoGetIssueQuotePolicyRequest({
            idOperation: props.match.params.idOperation
          }).then(async (response) => {
            if (response.status === 200 && response.data?.ret_value?.policyNumber) {
              const referenceNumber = response.data?.ret_value?.policyNumber;
              // ######################## Issue Quote Policy ######################################

              try {
                await useSaveQuestionsPaymentsRequest({
                  questionnaire: {
                    coverageOptionSelected: coverageOption,
                    idProductPlan: idProductPlanSelected,
                    idPersonRelationship,
                    idPersonRelationshipLimit: coverageCalcList[coverageOption]?.coverageLimit,
                  },
                  coverageOptionSelected: coverageOption,
                  idPersonRelationship,
                  idPersonRelationshipLimit: coverageCalcList[coverageOption]?.coverageLimit,
                  idProductPlan: idProductPlanSelected,
                  isDraft: false,
                  generateContract: documentOrder.genCertificate,
                  referenceNumber,
                  files,
                  isSompoCreatePolicy: ![26, 27].includes(operation?.idDomain),
                  isRefund: !generateBill
                }).then((response) => {
                  if (response.status !== 200) {
                    return mc.error("Ocorreu um erro durante a solicitação.");
                  } else {
                    //const { idIssueOperation } = response?.data?.ret_value || {};
                    //setIdIssueOperation(idIssueOperation);
                    history.push(`/payment-pack/${props.match.params.idOperation}`);
                    return mc.success(`Emissão ${operation?.idDomain === 26 ? 'da apólice' : 'do endosso'} realizada com sucesso.`);
                  }
                })
              } catch (e) {
                return mc.error(`Ocorreu um erro durante a solicitação.`);
              }
            } else {
              return mc.error(`Erro na requisição do sistema externo. Não foi possível emitir o número ${operation?.idDomain === 26 ? 'da apólice' : 'do endosso'}.`);
            }
          }).catch((e) => {
            if (e.response?.data?.ret_msg_details.includes('código seguradora')) {
              return mc.error(e.response?.data?.ret_msg_details.split('"')[1].slice(5));
            } else {
              return mc.error(`Erro na requisição do sistema externo. Não foi possível emitir o número ${operation?.idDomain === 26 ? 'da apólice' : 'do endosso'}.`);
            }
          })
        }
      }
    }).catch((e) => {
      return mc.error(`Ocorreu um erro durante a solicitação, tente novamente.`);
    })
  }

  useEffect(() => {
    if (useDeleteQuestionnaireStatus === 200) {
      useGetQuestionnairesAnswersRequest();
      if (executeBindRequest.current) {
        quoteIssue()
      } else {
        mc.success("Informações de Pagamento salvas com sucesso.");
        history.push('/list')
      }
    }
  }, [useDeleteQuestionnaireStatus]);

  const buildValidation = () => {
    const validationSchema = {};

    const fieldErrorMessage = (question) => {
      formikRef.current.isSubmitting && mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
      return "* Campo Obrigatório"
    };

    const questionnaire = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);
    for (const question of questionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;

      if ((question.idQuestion === 3464 || question.idQuestion === 3465) && question.answer === "Não" && question.visibleQuestion) {
        validationSchema[question.key] = yup.string().required(() => fieldErrorMessage(question)).oneOf(["Sim"]);
      } else {
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
          ? yup.string().required(() => fieldErrorMessage(question))
          : yup.string().notRequired();
      }
    }

    return yup.object().shape(validationSchema);
  }

  const hire = async (values, isDraft) => {
    try {
      if (isDraft) {
        handleSaveQuestionnaireAnswer(props.match.params.idOperation, null, null, isDraft);
      } else {
        buildValidation().validate(values, { abortEarly: false })
          .then(() => {
            const validationResult = true;
            if (validationResult) handleSaveQuestionnaireAnswer(props.match.params.idOperation, null, null, isDraft);
          })
          .catch((e) => {
            onValidationError(e, mc, formikRef, questionnaire, [...information])
          })
      }

      executeBindRequest.current = !isDraft;
    } catch (e) {
      updateIsLoadingStatus(false);
      mc.error(`Ocorreu um erro durante a solicitação.`);
      console.log("hire error", e);
    }
  }

  const handleValidationsSubmittedForm = (draft) => {
    if (draft) return true;
    let validationResult = true;

    const endTermDate = questionnaire.find(qst => qst.idQuestion === 1568);
    if (endTermDate?.answer) {
      if (moment(endTermDate.answer).isBefore(new Date(), 'day')) {
        validationResult = false;
        mc.error(
          `A data do fim de vigência deve ser maior ou igual a data de hoje para a efetivação do ${operation?.idDomain === 26 ? 'seguro' : 'endosso'}`
        );
      }
    }

    return validationResult;
  }

  useEffect(() => {
    buildValidation();
  }, [questionnaire]);

  useEffect(() => {
    async function start() {
      if (getQuestionnaire.current) return;
      if (isEmpty(permissions)) return;
      try {
        handleOperationInfo();
        useGetDocumentsRequest(null, { idDomain: 261 });
      } catch (e) {
        updateIsLoadingStatus(false);
      }
    }
    start();

  }, [permissions])

  const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups, isDraft = true) => {

    const body = { questionnaireAnswers: cloneDeep(questionnaire) };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          case 'INFORMATION':
            multipleFields = cloneDeep(information);
            break;
          case 'PAYMENT_INSTALLMENTS':
            multipleFields = cloneDeep(installments);
            break;
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map(group => {
          if (group?.length) {
            const rootQuestion = group.find(question => !question.idQuestionRoot);
            const childrenQuestions = group.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions;
            if (!onlyQuestions || formattedGroups) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
            }
          }
        })
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(question => {
      return (question?.behaviorObject?.sectionName && SECTIONS[question?.behaviorObject?.sectionName]);
    });

    let childrenQuestionIds = [];
    for (const question of body.questionnaireAnswers) {
      if (question) {
        if (
          (
            question.idDomainQuestion === 270 ||
            question.idDomainQuestion === 271 ||
            (question.idDomainQuestion === 44 && typeof question.answer === 'object')
          ) && question.answer
        ) {
          try {
            question.answer = JSON.stringify(question.answer)
          } catch (e) {
          }
        }

        if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
          if (question?.childrenQuestions?.length) {
            const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
            childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
          }
        } else {
          question.childrenQuestions = [];
        }
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(v => !childrenQuestionIds.includes(v.idQuestion))

    if (onlyQuestions) return body.questionnaireAnswers;

    const effectiveDateQuestion = body.questionnaireAnswers.find(qst => qst.idQuestion === 3520)

    if (!isDraft && !effectiveDateQuestion?.answer) {
      body.questionnaireAnswers = body.questionnaireAnswers.map(qst => {
        if (qst.idQuestion === 3520) {
          return {
            ...qst,
            answer: new Date().toISOString()
          }
        }
        return qst;
      })
    }

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  function generateInstallments(interestRate, numberOfInstallments, firstInstallmentDueDate) {
    const coverageAmount = coverageCalcList[coverageOption]?.adjustmentCoverageAmount != null ? coverageCalcList[coverageOption]?.adjustmentCoverageAmount : coverageCalcList[coverageOption]?.coverageAmount;
    const installmentValue = PMT(
      interestRate,
      numberOfInstallments,
      coverageAmount
    );

    let installmentsAux = cloneDeep(installments);
    if (!installmentsAux.length) return;
    setInstallments([]);
    updateIsLoadingStatus(true);

    setTimeout(() => {
      updateIsLoadingStatus(false);
      const newInstallments = [];
      for (let i = 1; i <= numberOfInstallments; i++) {
        const installmentNumber = Object.assign({}, installmentsAux[0].find(qst => qst.idQuestion === 3461));
        const total = Object.assign({}, installmentsAux[0].find(qst => qst.idQuestion === 3463));
        const dueDate = Object.assign({}, installmentsAux[0].find(qst => qst.idQuestion === 3462));
        installmentNumber.key = `${camelCase(installmentNumber.dsQuestion)}_${installmentNumber.idQuestion}${uniqueId()}_${uniqueId()}`;
        installmentNumber.idAnswerOption = null;
        installmentNumber.idPerson = null;
        installmentNumber.idQuestionnaireAnswers = null;
        installmentNumber.idQuestionnaireAnswersParent = null;
        installmentNumber.idQuestionnaireAnswersRoot = null;

        total.key = `${camelCase(total.dsQuestion)}_${total.idQuestion}${uniqueId()}_${uniqueId()}`;
        total.idAnswerOption = null;
        total.idPerson = null;
        total.idQuestionnaireAnswers = null;
        total.idQuestionnaireAnswersParent = null;
        total.idQuestionnaireAnswersRoot = null;

        dueDate.key = `${camelCase(dueDate.dsQuestion)}_${dueDate.idQuestion}${uniqueId()}_${uniqueId()}`;
        dueDate.idQuestionnaireAnswers = null;
        dueDate.idAnswerOption = null;
        dueDate.idPerson = null;
        dueDate.idQuestionnaireAnswersParent = null;
        dueDate.idQuestionnaireAnswersRoot = null;

        installmentNumber.answer = String(i);
        total.answer = String(installmentValue);
        
        // Regra de negócio SOMPO RCG:
        // - Primeira parcela: usa firstInstallmentDueDate (data de emissão + 10 dias, ou customizada em casos de entrada/renovação)
        // - Demais parcelas: data de emissão + (i-1) meses
        if (i === 1) {
          // Primeira parcela: usa firstInstallmentDueDate que já foi calculado considerando os 10 dias ou casos especiais
          dueDate.answer = moment(firstInstallmentDueDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
          // Demais parcelas: (i-1) meses a partir da data de emissão (hoje)
          dueDate.answer = moment().add(i - 1, 'months').format('YYYY-MM-DD');
        }
        if (i === 1) {
          const mask = total.fieldMask;
          const masked = IMask.createMask(mask);

          setTotalInstallments(
            `R$ ${masked.resolve(String(installmentValue * numberOfInstallments).replace('.', ','))}`
          );
        }

        const installment = [installmentNumber, total, dueDate].sort((a, b) => a.sequenceQuestion - b.sequenceQuestion)

        newInstallments.push(installment);
      }
      setInstallments(newInstallments);
    }, 500);
  }

  const handlePaymentQuestionary = (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    filteredQuestionnaire = cloneDeep(filteredQuestionnaire)
    if ([3459, 3460, 3478, 1586].includes(question.idQuestion)) {
      const selectedPaymentMethod = filteredQuestionnaire.find(qst => qst.idQuestion === 3459)?.answer;
      const selectedInstallmentMethod = filteredQuestionnaire.find(qst => qst.idQuestion === 3460)?.answer;

      if (!selectedPaymentMethod || !selectedInstallmentMethod) {
        let idsAnswersToDelete = [];
        for (const group of installments) {
          idsAnswersToDelete = [
            ...idsAnswersToDelete,
            ...questionnaireAnswersToDelete,
            ...group.map(qst => (
              qst.idQuestionnaireAnswers
            )).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
          ]
        }

        setQuestionnaireAnswersToDelete(idsAnswersToDelete);
        setVisibleSection(false);

        const installmentNumber = installments[0].find(qst => qst.idQuestion === 3461);
        const total = installments[0].find(qst => qst.idQuestion === 3463);
        const dueDate = installments[0].find(qst => qst.idQuestion === 3462);

        installmentNumber.key = null;
        installmentNumber.answer = '';
        installmentNumber.idAnswerOption = null;
        installmentNumber.idPerson = null;
        installmentNumber.idQuestionnaireAnswersParent = null;
        installmentNumber.idQuestionnaireAnswersRoot = null;

        total.key = null;
        total.answer = '';
        total.idAnswerOption = null;
        total.idPerson = null;
        total.idQuestionnaireAnswersParent = null;
        total.idQuestionnaireAnswersRoot = null;

        dueDate.key = null;
        dueDate.answer = '';
        dueDate.idAnswerOption = null;
        dueDate.idPerson = null;
        dueDate.idQuestionnaireAnswersParent = null;
        dueDate.idQuestionnaireAnswersRoot = null;

        const installment = [installmentNumber, total, dueDate];
        setInstallments([installment]);

        const questionFirstInstallmentDueDate = filteredQuestionnaire.find(qst => qst.idQuestion === 3478);
        setFieldValue(questionFirstInstallmentDueDate.key, '');

        setFilteredQuestionnaire(filteredQuestionnaire.map(question => {
          return question.idQuestion === 3478 ?
            question = {
              ...question,
              answer: '',
              answerJson: '',
            } : question
        }))
      } else {
        let idsAnswersToDelete = [];
        for (const group of installments) {
          idsAnswersToDelete = [
            ...idsAnswersToDelete,
            ...questionnaireAnswersToDelete,
            ...group.map(qst => (
              qst.idQuestionnaireAnswers
            )).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
          ]
        }

        setQuestionnaireAnswersToDelete(idsAnswersToDelete);
        setVisibleSection(true);

        const [thereIsADownPayment, numberOfInstallments, interestRate] = JSON.parse(selectedInstallmentMethod)

        // const interestFree = filteredQuestionnaire.find(qst => qst.idQuestion === 1586)?.idAnswerOption === 7214;

        const questionFirstInstallmentDueDate = filteredQuestionnaire.find(qst => qst.idQuestion === 3478);

        let firstInstallmentDueDate;

        if (!thereIsADownPayment && !operation?.isRenewal) {
          firstInstallmentDueDate = moment().add(10, 'days').format('DD/MM/YYYY');
        } else if (question.idQuestion === 3478) {
          firstInstallmentDueDate = moment(answer, 'YYYY-MM-DD').format('DD/MM/YYYY');
        } else if (moment(questionFirstInstallmentDueDate?.answer, 'DD/MM/YYYY').isBefore(moment().add(29, 'days'))) {
          firstInstallmentDueDate = questionFirstInstallmentDueDate.answer
        } else {
          firstInstallmentDueDate = moment().add(10, 'days').format('DD/MM/YYYY');
        }

        setFieldValue(questionFirstInstallmentDueDate.key, firstInstallmentDueDate);

        const fieldMaxValue = operation?.isRenewal ? 90 : thereIsADownPayment ? 29 : null;
        const disabled = operation?.isRenewal ? false : !thereIsADownPayment;

        setFilteredQuestionnaire(filteredQuestionnaire.map(question => {
          return question.idQuestion === 3478 ?
            question = {
              ...question,
              disabled: !thereIsADownPayment,
              answer: moment(firstInstallmentDueDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              answerJson: moment(firstInstallmentDueDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              behaviorObject: {
                ...question.behaviorObject,
                fieldMaxValue,
              }
            } : question
        }))

        generateInstallments(isRefund ? 0 : interestRate, numberOfInstallments, firstInstallmentDueDate);
      }
    }
  }

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
      idOperation={operation?.idOperation}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={operation?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            history={history}
            idOperation={props.match?.params?.idOperation}
            idProduct={operation?.idProduct || ''}
            permissions={permissions}
          />
        </Col>
      </Row>

      <Content>
        <Formik
          innerRef={formikRef}
          initialValues={{}}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          onSubmit={() => {
            setDialogConfirmationEmission({ visible: true })
          }}
        >
          {({ values, setFieldValue, errors, setFieldError }) => {
            return (
              <Form>
                <ModalEditConfirmation
                  show={dialogConfirmationEmission.visible}
                  title={`EFETIVAR ${operation?.idDomain === 26 ? 'SEGURO' : 'ENDOSSO'}`}
                  messages={[
                    () => {
                      return (
                        <>
                          {(!tomadorInfo.hasAttachtments || tomadorInfo.needWarranty) && (
                            <p style={{ display: 'flex', fontSize: '16px' }}>
                              {`Você deseja confirmar a emissão ${operation?.idDomain === 26 ? 'desta apólice' : 'deste endosso'}?`}
                            </p>
                          )}
                        </>
                      )
                    }
                  ]}
                  onConfirm={() => hire(values, false)}
                  onCancel={() => setDialogConfirmationEmission({ ...dialogConfirmationEmission, visible: false })}
                />
                <Row>
                  <Col md={3} >
                    {(coverageCalcList && coverageCalcList[coverageOption]) && (
                      <>
                        <TitleBar>
                          <TitleInfo>OPÇÃO {coverageOption + 1}</TitleInfo>
                          {!isBound && <TitleAlter onClick={() => { history.push(`/quote/plans/${operation?.idProduct}/${props.match?.params?.idOperation}`) }}>Alterar</TitleAlter>}
                        </TitleBar>
                        <OptionSummary>
                          <OptionSummaryTitle>Importância Segurada</OptionSummaryTitle>
                          <OptionSummaryValue bold>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageLimit)}
                          </OptionSummaryValue>

                          {!isRefund ? <>
                            <OptionSummaryTitle>Prêmio líquido</OptionSummaryTitle>
                            <OptionSummaryValue>
                              R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageAmountTaxLess)}
                            </OptionSummaryValue>
                          </> : <></>}

                          <OptionSummaryTitle>IOF</OptionSummaryTitle>
                          <OptionSummaryValue>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageTax)}
                          </OptionSummaryValue>

                          <OptionSummaryTitle>Prêmio Total {isRefund ? "(valor a ser reembolsado/restituído)" : "(Valor a ser pago)"}</OptionSummaryTitle>
                          <OptionSummaryValue bold>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].adjustmentCoverageAmount != null ? coverageCalcList[coverageOption].adjustmentCoverageAmount : coverageCalcList[coverageOption].coverageAmount)}
                          </OptionSummaryValue>
                        </OptionSummary>
                      </>)
                    }
                  </Col>

                  <Col md={9} >
                    <Row>
                      <Col>
                        <TitleBar>
                          <TitleInfo>DADOS DE PAGAMENTO</TitleInfo>
                        </TitleBar>
                        <OptionSummary>
                          <GroupFormContainer>
                            {(handleCollapse, collapseAll, collapseChild) => (<div>
                              <FormContainer
                                toggle={collapseAll}
                                enumerate={"1"}
                                noTitlePadding
                                title="Informação de Pagamento"
                                hide={noRefoundOrPayment}
                              >
                                <FormSectionGlobal sectionName="PAYMENT"
                                  disableAll={isBound}
                                  questionnaire={questionnaire}
                                  setQuestionnaire={setQuestionnaire}
                                  values={values}
                                  formikRef={formikRef}
                                  idOperationParent={props.match?.params?.idOperationParent}
                                  idProduct={operation?.idProduct}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  setFieldError={setFieldError}
                                  ignoreModality
                                  permissions={permissions}
                                  onQuestionChange={(
                                    question,
                                    value,
                                    setFieldValue,
                                    questionnaireUpdated
                                  ) => handlePaymentQuestionary(
                                    question,
                                    value,
                                    questionnaireUpdated,
                                    setQuestionnaire,
                                    setFieldValue
                                  )}
                                />
                              </FormContainer>

                              <FormContainer
                                toggle={collapseAll}
                                noTitlePadding
                                title="Resumo de pagamento"
                                hide={!noRefoundOrPayment && (!visibleSection || !installments.length)}
                              >
                                {!noRefoundOrPayment && installments && installments.map((questions, index) => (
                                  <FormSectionGlobal
                                    key={index}
                                    sectionName={'PAYMENT_INSTALLMENTS'}
                                    values={values}
                                    errors={errors}
                                    sectionIndex={index}
                                    setFieldValue={setFieldValue}
                                    setFieldError={setFieldError}
                                    questionnaire={questions}
                                    setQuestionnaire={(questionnaire) => setInstallments(installments.map((v, i) => i === index ? questionnaire : v))}
                                    disableAll={isBound}
                                    formikRef={formikRef}
                                    ignoreModality
                                    permissions={permissions}
                                  />
                                ))}
                                <b style={{ textAlign: 'right' }}>
                                  {isRefund ? "Total á restituir: " : "Total à pagar: "}
                                  {noRefoundOrPayment ?
                                    `R$ ${maskHelper.formatCurrency(
                                      authContext,
                                      coverageCalcList[coverageOption].adjustmentCoverageAmount != null ?
                                        coverageCalcList[coverageOption].adjustmentCoverageAmount :
                                        coverageCalcList[coverageOption].coverageAmount
                                    )}` : totalInstallments
                                  }
                                </b>
                              </FormContainer>
                            </div>)}
                          </GroupFormContainer>
                        </OptionSummary>
                      </Col>
                    </Row>
                    <Row>
                      <Col style={{ marginTop: '40px' }}>
                        <FormSectionGlobal
                          sectionName="TERMS"
                          disableAll={isBound}
                          questionnaire={questionnaire}
                          setQuestionnaire={setQuestionnaire}
                          values={values}
                          formikRef={formikRef}
                          idOperationParent={props.match?.params?.idOperationParent}
                          idProduct={operation?.idProduct}
                          errors={errors}
                          setFieldValue={setFieldValue}
                          setFieldError={setFieldError}
                          ignoreModality
                          permissions={permissions}
                          onQuestionChange={(
                            question,
                            answer,
                            filteredQuestionnaire,
                            setFilteredQuestionnaire,
                            setFieldValue
                          ) => handlePaymentQuestionary(
                            question,
                            answer,
                            filteredQuestionnaire,
                            setFilteredQuestionnaire,
                            setFieldValue
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>


                <ButtonContainer style={{ marginTop: 60 }}>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <ButtonContent>
                    <HasPermission permission={!isBound && permissions.MARKETS_SELECTION}>
                      <Button
                        id="btnSave"
                        type="button"
                        style={{ marginLeft: 15 }}
                        // @ts-ignore
                        onClick={() => {
                          validationSchema.current.validate(values)
                            .then(() => {
                              hire(values, true)
                            })
                            .catch((e) => {
                              console.log('validation error', e)
                              mc.error('Por favor, preencha todos os campos obrigatórios (*)')
                            })
                        }}
                        primary
                      >
                        SALVAR
                      </Button>
                    </HasPermission>
                    <HasPermission permission={!isBound && (permissions.ORDER_TO_BIND_GENERATE && operation?.idDomain == 26 || permissions.EXECUTE_ENDORSEMENT && operation?.idDomain !== 26)}>
                      <Button
                        id="btnSave"
                        type="submit"
                        style={{ marginLeft: 15 }}
                        // @ts-ignore
                        // disabled={!idPersonRelationship}
                        onClick={() => {
                          validationSchema.current.validate(values).catch((e) => {
                            console.log('validation error', e)
                            mc.error('Por favor, preencha todos os campos obrigatórios (*)')
                          })
                        }}
                        custom={[Colors.WHITE, Colors.TERTIARY]}
                      >
                        {`EFETIVAR ${operation?.idDomain === 26 ? 'SEGURO' : 'ENDOSSO'}`}
                      </Button>
                    </HasPermission>
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </Content>
    </Layout >
  )
}